import axios from 'axios';
import authHeader from "@/service/auth-header";

class BillingPlanComponentService {

    async getBillingPlanComponentsForBillingPlan(billingPlanId) {
        console.log("[BillingPlanComponentService][getBillingPlanComponentsForBillingPlan] Before making Rest call. ID = ", billingPlanId);

        return await axios.get(`/api/billingplancomponent/billingplan/${billingPlanId}`,{ headers: authHeader() })
    }

    async createBillingPlanComponent(billingPlanId, data) {
        console.log("[BillingPlanComponentService][createBillingPlanComponent] Before making Rest call. Data = ", data);

        return await axios.post(`/api/billingplancomponent/${billingPlanId}`, data,{ headers: authHeader() });
    }

    async updateBillingPlanComponent(billingPlanComponentId, data) {
        return await axios.put(`/api/billingplancomponent/${billingPlanComponentId}`, data,{ headers: authHeader() });
    }

    async deleteBillingPlanComponent(billingPlanComponentId) {
        return await axios.delete(`/api/billingplancomponent/${billingPlanComponentId}`,{ headers: authHeader() })
    }

}

export default new BillingPlanComponentService();
